import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { SettingDao } from '../models/settings/setting-dao.model';
import { ApiService } from '../services/api.service';
import { KeyValuePair } from './../models/settings/key-value-pair.model';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private _http = inject(HttpClient);
  private _apiService = inject(ApiService);

  public async loadUserSettings(): Promise<KeyValuePair[]> {
    const res = firstValueFrom(
      await this._http.get<KeyValuePair[]>(`${this._apiService.getApiUrl()}/settings`).pipe(
        map((settings) => {
          for (const setting of settings) {
            setting.value = JSON.parse(setting.value);
          }
          return settings;
        }),
      ),
    );
    return res;
  }

  public async saveUserSettings(settings: SettingDao): Promise<any> {
    const settingsDto = settings.getSettingsJson();
    return firstValueFrom(this._http.post(`${this._apiService.getApiUrl()}/settings`, settingsDto));
  }

  public async loadGlobalSettings(): Promise<KeyValuePair[]> {
    const res = firstValueFrom(
      await this._http.get<KeyValuePair[]>(`${this._apiService.getApiUrl()}/settings/global`).pipe(
        map((settings) => {
          for (const setting of settings) {
            setting.value = JSON.parse(setting.value.toLowerCase());
          }
          return settings;
        }),
      ),
    );
    return res;
  }
}
